import React, { useEffect, useState, useRef } from 'react'
import { Button, Layout, PageHeader } from 'antd'
import { useParams, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import {
	getDetail,
	listRows,
	editRow,
	createRow,
	deleteRow,
	setShowModal,
	createColumn,
	editDatabaseName,
	editColumnName,
	deleteColumn,
} from '~/states/modules/internalDatabaseDetails'

import MainLayout from '~/components/mainLayout'
import EditableDataTable from 'components/editableDataTable'
import BreadCrumb from '~/components/breadCrumb'
import { getColumns, getDataSource } from './utils'
import AddColumnModal from './components/modal'
import ListItemDocuments from '~/components/modalListDocuments'

const InternalDatabaseDetails = () => {
	const { id } = useParams()
	const dispatch = useDispatch()
	const history = useHistory()
	const [searchTerm, setSearchTerm] = useState('')
	const [showDocumentModal, setShowDocumentModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState('')
	const [modalTitle, setModalTile] = useState('')
	const targetRef = useRef(null)

	const { database, items, showModal, loading } = useSelector(
		({ internalDatabaseDetails }) => internalDatabaseDetails
	)

	useEffect(() => {
		dispatch(getDetail({ id }))
		dispatch(listRows({ id, searchTerm }))
	}, [dispatch, id, searchTerm])

	const handleSaveRow = (data) => {
		dispatch(
			editRow({
				...data,
				page: items.pages.page,
				per_page: items.pages.per_page,
				searchTerm: searchTerm,
				databaseId: id,
			})
		)
	}

	const handleDelete = (row) => {
		dispatch(deleteRow(row))
	}

	const handleModalListDocuments = (row) => {
		setModalTile(row[Object.keys(row)[0]])
		setSelectedItem(row.key.toString())
		setShowDocumentModal(true)
	}

	const handleCancelDocumentModal = () => {
		setShowDocumentModal(false)
	}

	const handleCreateRow = () => {
		const lastPage = Math.ceil(items.pages.total / items.pages.per_page) || 1
		dispatch(createRow({ page: lastPage, per_page: items.pages.per_page }))
		targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
	}

	const handleCreateColumn = (column_name) => {
		dispatch(setShowModal(false))
		dispatch(
			createColumn({
				name: column_name,
				data_type: 'string',
				is_searchable: true,
			})
		)
	}

	const handleShowModal = () => {
		dispatch(setShowModal(true))
	}

	const handleCloseModal = () => {
		dispatch(setShowModal(false))
	}

	const handleEditDatabaseName = (name) => {
		dispatch(editDatabaseName(name))
	}

	const handleChangeColumnName = (old_name, new_name) => {
		dispatch(editColumnName({ old_name, new_name }))
	}

	const handleDeleteColumn = (column_name) => {
		dispatch(deleteColumn(column_name))
	}

	const getDatabases = ({ id, page, perPage, search }) => {
		dispatch(listRows({ id, page, perPage, search }))
	}

	const buttons = [
		<Button
			key="1"
			onClick={handleCreateRow}
			disabled={database.structure.length === 0}
			type="primary">
			Nova linha
		</Button>,
		<Button key="2" onClick={handleShowModal} type="primary">
			Nova coluna
		</Button>,
	]

	return (
		<MainLayout selectedKey={'database'}>
			<Layout style={{ padding: '0', background: '#fff', width: '100%' }}>
				<PageHeader>
					<BreadCrumb
						onClickParent={() => history.push('/internaldatabases')}
						parent="Banco de dados"
						current={database.name}
						editable={true}
						onEdit={handleEditDatabaseName}
					/>
				</PageHeader>
				<AddColumnModal
					title="Adicionar coluna"
					handleCancel={handleCloseModal}
					handleCreate={handleCreateColumn}
					showModal={showModal}
				/>
				<ListItemDocuments
					visible={showDocumentModal}
					onCancel={handleCancelDocumentModal}
					idDataBase={id}
					selectedItem={selectedItem}
					type="internal_database"
					modalTitle={modalTitle}
				/>
				<div ref={targetRef}>
					<EditableDataTable
						loading={loading}
						buttons={buttons}
						onSearch={({ search }) => setSearchTerm(search)}
						pages={items.pages}
						id={id}
						onChangePageNumber={getDatabases}
						dataSource={getDataSource(items.data)}
						columns={getColumns(
							database.structure,
							handleDelete,
							handleModalListDocuments
						)}
						saveData={handleSaveRow}
						handleChangeColumnName={handleChangeColumnName}
						handleDeleteColumn={handleDeleteColumn}
					/>
				</div>
			</Layout>
		</MainLayout>
	)
}

export default InternalDatabaseDetails
